/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: ooL7EhXDmFQWnW9sxtchhE
// Component: VqaN_WL-stA

import * as React from "react";

import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  Flex as Flex__,
  hasVariant,
  renderPlasmicSlot,
  SingleBooleanChoiceArg,
  StrictProps,
  useDollarState,
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";

import NavTeamButton from "../../components/dashboard/NavTeamButton"; // plasmic-import: Mql0DTa_iO/component
import NavWorkspaceButton from "../../components/dashboard/NavWorkspaceButton"; // plasmic-import: Cma6XahJmS/component
import { _useGlobalVariants } from "./plasmic"; // plasmic-import: ooL7EhXDmFQWnW9sxtchhE/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: ooL7EhXDmFQWnW9sxtchhE/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import "../PP__plasmickit_dashboard.css"; // plasmic-import: ooL7EhXDmFQWnW9sxtchhE/projectcss
import sty from "./PlasmicNavTeamSection.module.css"; // plasmic-import: VqaN_WL-stA/css

createPlasmicElementProxy;

export type PlasmicNavTeamSection__VariantMembers = {
  selected: "selected";
};
export type PlasmicNavTeamSection__VariantsArgs = {
  selected?: SingleBooleanChoiceArg<"selected">;
};
type VariantPropType = keyof PlasmicNavTeamSection__VariantsArgs;
export const PlasmicNavTeamSection__VariantProps = new Array<VariantPropType>(
  "selected"
);

export type PlasmicNavTeamSection__ArgsType = {
  name?: React.ReactNode;
  href?: string;
  children?: React.ReactNode;
};
type ArgPropType = keyof PlasmicNavTeamSection__ArgsType;
export const PlasmicNavTeamSection__ArgProps = new Array<ArgPropType>(
  "name",
  "href",
  "children"
);

export type PlasmicNavTeamSection__OverridesType = {
  root?: Flex__<"div">;
  button?: Flex__<typeof NavTeamButton>;
  freeBox?: Flex__<"div">;
};

export interface DefaultNavTeamSectionProps {
  name?: React.ReactNode;
  href?: string;
  children?: React.ReactNode;
  selected?: SingleBooleanChoiceArg<"selected">;
  className?: string;
}

const $$ = {};

function PlasmicNavTeamSection__RenderFunc(props: {
  variants: PlasmicNavTeamSection__VariantsArgs;
  args: PlasmicNavTeamSection__ArgsType;
  overrides: PlasmicNavTeamSection__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants,
  };

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const stateSpecs: Parameters<typeof useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "selected",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.selected,
      },
    ],
    [$props, $ctx, $refs]
  );

  const globalVariants = _useGlobalVariants();

  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs,
  });

  const styleTokensClassNames = _useStyleTokens();

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "all",
        "root_reset_ooL7EhXDmFQWnW9sxtchhE",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.root,
        { [sty.rootselected]: hasVariant($state, "selected", "selected") }
      )}
    >
      <NavTeamButton
        data-plasmic-name={"button"}
        data-plasmic-override={overrides.button}
        href={args.href}
        name={renderPlasmicSlot({
          defaultContents: "Team name",
          value: args.name,
        })}
        selected={hasVariant($state, "selected", "selected") ? true : undefined}
      />

      <div
        data-plasmic-name={"freeBox"}
        data-plasmic-override={overrides.freeBox}
        className={classNames("all", sty.freeBox, {
          [sty.freeBoxselected]: hasVariant($state, "selected", "selected"),
        })}
      >
        {renderPlasmicSlot({
          defaultContents: (
            <React.Fragment>
              <NavWorkspaceButton
                className={classNames(
                  "__wab_instance",
                  sty.navWorkspaceButton__thJNj
                )}
                noIcon={true}
              />

              <NavWorkspaceButton
                className={classNames(
                  "__wab_instance",
                  sty.navWorkspaceButton__xDhr
                )}
                name={"Workspace B"}
                noIcon={true}
              />
            </React.Fragment>
          ),
          value: args.children,
        })}
      </div>
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ["root", "button", "freeBox"],
  button: ["button"],
  freeBox: ["freeBox"],
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  button: typeof NavTeamButton;
  freeBox: "div";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicNavTeamSection__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicNavTeamSection__VariantsArgs;
    args?: PlasmicNavTeamSection__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & // Specify variants directly as props
  Omit<PlasmicNavTeamSection__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicNavTeamSection__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicNavTeamSection__ArgProps,
          internalVariantPropNames: PlasmicNavTeamSection__VariantProps,
        }),
      [props, nodeName]
    );
    return PlasmicNavTeamSection__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName,
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicNavTeamSection";
  } else {
    func.displayName = `PlasmicNavTeamSection.${nodeName}`;
  }
  return func;
}

export const PlasmicNavTeamSection = Object.assign(
  // Top-level PlasmicNavTeamSection renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    button: makeNodeComponent("button"),
    freeBox: makeNodeComponent("freeBox"),

    // Metadata about props expected for PlasmicNavTeamSection
    internalVariantProps: PlasmicNavTeamSection__VariantProps,
    internalArgProps: PlasmicNavTeamSection__ArgProps,
  }
);

export default PlasmicNavTeamSection;
/* prettier-ignore-end */
